import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { NgwWowService } from 'ngx-wow';
import { MessageService } from '../service/message.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
   message={
    messagerName:null,
    messageEmail:null,
    messageCompany:null,
    messagePhone:null
  }

  messageForm=new FormGroup({
    messagerName:new FormControl(this.message.messagerName,Validators.required),
    messageEmail:new FormControl(this.message.messageEmail,Validators.required),
    messageCompany:new FormControl(this.message.messageCompany,Validators.required),
    messagePhone:new FormControl(this.message.messagePhone,Validators.required)
  });

  constructor(private router: Router, private wowService: NgwWowService,
    private httpClient: HttpClient,
    private service: MessageService,private location: Location) {
    this.wowService.init();

  }
//儲存資料+傳送信件
  onSubmit(){
    console.log(this.messageForm.value)
      this.service.sMessage(this.messageForm.value).subscribe((result)=>{
        let param ={
          title:"你有一則來自"+this.messageForm.value.messagerName + "小姐/先生的留言!",
          content:
                "留言自:KhaiKang-企業獨立視訊通話APP\n"+
                "聯絡信箱:"+this.messageForm.value.messageEmail+"\n"+
                "組織名稱:"+this.messageForm.value.messageCompany+"\n"+
                "連絡電話:"+this.messageForm.value.messagePhone
        }
        console.log("result is here",result)
        if(result.result){
          this.service.sendMail(param).subscribe(data=>{
            console.log("成功送出");
          })
          alert('已成功送出，感謝您，我們將會盡快與您聯絡');
          this.location.back();
        }
      })
    }


  ngOnInit(): void {
    this.wowService.init();
  }

}
